<template>
  <div :style="style"><slot/></div>
</template>

<script>
import colors from '@/services/colors'

export default {
  name: 'LightText',
  props: {
    marginOff: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    style() {
      return {
        color: colors.red,
        marginTop: this.marginOff ? 0 : '27px',
        marginBottom: this.marginOff ? 0 : '62px',
      }
    }
  }
}
</script>

<style lang="scss" scoped>
div {
  margin-top: 27px;
  margin-bottom: 62px;
  font-size: 16px;
  font-weight: 400;
  strong {
    font-weight: 600;
  }
}
</style>
